import { useCallback, useContext, useState } from 'react';
import { EmployerContext, UserContext } from 'contexts';
import { useNavigate } from 'react-router-dom';
import { CONGRATULATIONS } from 'constants/pathNames';
import { createEmployer } from 'services/post/createEmployer';

export const useEmployer = ({
  companyName,
  country,
  postalCode,
  clientWebSiteUrl,
  stateProvince,
  streetAddress,
  city,
  industryKey,
}) => {
  const [isLoadingEmployer, setLoading] = useState(false);
  const { setEmployerResult } = useContext(EmployerContext);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const getEmployer = useCallback(async () => {
    try {
      const token = await user?.getIdToken();
      const employer = await createEmployer({
        clientName: companyName,
        countryCode: country,
        id: user?.uid,
        streetAddress,
        postalCode,
        state: stateProvince,
        clientWebSiteUrl,
        city,
        token,
        industryKey,
      });
      setEmployerResult(employer);
      navigate(CONGRATULATIONS);
    } finally {
      setLoading(false);
    }
  }, [
    companyName,
    country,
    postalCode,
    clientWebSiteUrl,
    stateProvince,
    streetAddress,
    city,
    industryKey,
    user,
    navigate,
    setEmployerResult,
  ]);

  return {
    isLoadingEmployer,
    getEmployer,
  };
};
